import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { Large } from '@dbk/ui-text';
import ScrollableLayout from '../../../components/common/scrollable-layout';
import { LoadingCircle } from '../../../components/common/loading';
import { Checkbox } from '@dbk/ui-forms';
import { List, ListItem } from '@dbk/ui-list';
import Button from '@dbk/ui-buttons';
import Modal from '@dbk/ui-modal';
import { TermsConditions } from '../../modal-content';
let deselectConfirmPopupFlag = true
let firstTimeSubscriptionData = [];
let finalAckStatus = [];


class DocSignSubscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
      checkeCount: 0,
      count: 0,
      selectedStates: [],
      warningMsg: false,
      singlePortfolio: false,
      saveDocSignSubscriptionButtonClicked: false,
      susbscriptionConfirmed: false,
      ackStatus: [],
      selectAllStatus: false,
      termsConditionsClicked: false,
      accountDeSelectConfirmationPopUp: false,
      deactivatedAllPortfolios: false,
      deactivatedAllPortfoliosPopup: false
    };
    this.props.getDocSignSubscriptionData();
    this.goToPortfolio = this.goToPortfolio.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.prepareDataList = this.prepareDataList.bind(this);
    this.selectAll = this.selectAll.bind(this);
    this.renderTabletBlock = this.renderTabletBlock.bind(this);
    this.saveDocSignSubscriptionClicked = this.saveDocSignSubscriptionClicked.bind(this);
    this.termsConditionsButtonClicked = this.termsConditionsButtonClicked.bind(this);

  }

  componentDidMount() {
    const {
      deviceInfo
    } = this.props;
  }

  componentDidUpdate(prevProp, prevState) {
    if (this.props.docsign.subscriptionData != prevProp.docsign.subscriptionData) {
      if (this.props.docsign.subscriptionData != null && this.props.docsign.subscriptionData.length != 0) {
        this.prepareDataList();
      } else {
        this.setState({ warningMsg: true });
      }
    }
    if (this.props.docsign.saveClientSubscriptionResponse != prevProp.docsign.saveClientSubscriptionResponse) {
      if (this.props.docsign.saveClientSubscriptionResponse.status.toLowerCase() === "success") {
        const {
          i18n: { messages },
        } = this.props;
        if(this.state.deactivatedAllPortfolios){
          this.setState({
            deactivatedAllPortfoliosPopup: true,
            saveDocSignSubscriptionButtonClicked: false
          });
        } else {
           this.setState({
            susbscriptionConfirmed: true,
            saveDocSignSubscriptionButtonClicked: false
          });
        }
      }
    }
  }

  saveDocSignSubscriptionClicked = () => {
    const {
      docsign: { showDocsignBanner, firstTimeSubscription }
    } = this.props;
    let list = this.props.docsign.subscriptionData;

    if(showDocsignBanner && firstTimeSubscription){
      list.forEach(function (key, i) {
        list[i].ackStatus = !key.isChecked
        firstTimeSubscriptionData.push(list[i]);
      });
      this.handleValidationForSave();
    }

    let selectedList = this.state.selectedStates;
    deselectConfirmPopupFlag = true;
    selectedList.forEach(function (key, i) {
      if (key.isChecked) {
        deselectConfirmPopupFlag = false
      }
    });
    if (deselectConfirmPopupFlag) {
      this.setState({
        accountDeSelectConfirmationPopUp: true,
      });
    } else {
      this.setState({
        saveDocSignSubscriptionButtonClicked: true,
      });
      
      if(showDocsignBanner){
        this.props.saveDocSignSubscription(finalAckStatus);
      } else {
        this.props.saveDocSignSubscription(this.state.ackStatus);
      }

    }
  };

  termsConditionsButtonClicked = () => {
    this.setState({
      termsConditionsClicked: !this.state.termsConditionsClicked
    });
  };

  goToPortfolio() {
    this.props.changePage({ pathname: '/portfolios' }, true);
  }

  /*
    function for selecting all checkboxes
  */
  selectAll() {
    let getList = this.state.selectedStates;
    let selectAllStatus = this.state.selectAllStatus;

    getList.forEach(function (item, k) {
      if (item.docCount === 0 && !selectAllStatus) {
        item.isChecked = true;
      } else if (item.docCount === 0 && selectAllStatus) {
        item.isChecked = false;
      }
    });
    this.setState({ selectedStates: getList, selectAllStatus: !selectAllStatus });

    let arrayList = this.state.selectedStates;
    let selectedRowCount = 0;
    arrayList.forEach(function (dataRow, i) {
      if (dataRow.isChecked == true) {
        selectedRowCount = selectedRowCount + 1;
      }
    });
    this.setState({ checkeCount: selectedRowCount });
    this.handleValidationForSave();
  }

  /*
    function for preparing resultant JSON from muster data
    consist UI checkbox row shown to user
    flag isChecked :boolean value
  */

  prepareDataList() {
    let data = this.props.docsign.subscriptionData;
    let preparedData = [],
      checkListItem = [];
    let listItemCount,
      selectedRowCount = 0;
    data.forEach(function (dataRow, i) {
      checkListItem.push(dataRow);
    });

    checkListItem.forEach(function (listRow, j) {
      listRow.isChecked = listRow.ackStatus;
    });

    checkListItem.forEach(function (listRow, j) {
      if (listRow.isChecked == true) {
        selectedRowCount = selectedRowCount + 1;
      }
    });
    listItemCount = checkListItem.length;
    this.setState({
      selectedStates: checkListItem,
      count: listItemCount,
      checkeCount: selectedRowCount,
    });
  }

  handleChange(item) {
    if (item.docCount === 0) {
      let arrayList = this.state.selectedStates;
      let checkedCountTemp = 0;
      arrayList.forEach(function (dataRow, i) {
        if (dataRow.pfId == item.pfId) {
          dataRow.isChecked = !item.isChecked;
        }
      });
      arrayList.forEach(function (dataRow, i) {
        if (dataRow.isChecked == true) {
          checkedCountTemp = checkedCountTemp + 1;
        }
      });

      this.setState({
        selectedStates: arrayList,
        checkeCount: checkedCountTemp,
        selectAllStatus: checkedCountTemp === this.state.count
      });
      this.handleValidationForSave();
    }
  }

  handleValidationForSave() {

    const {
      docsign: { showDocsignBanner, firstTimeSubscription }
    } = this.props;

    let data = showDocsignBanner && firstTimeSubscription && firstTimeSubscriptionData && firstTimeSubscriptionData.length !== 0 ? firstTimeSubscriptionData :  this.props.docsign.subscriptionData;
    this.props.setFirstTimeSubscription(false);
    
    let selectedList = this.state.selectedStates;
    let ackStatus = [];
    let status = {};
    selectedList.forEach(function (key, i) {
      if (key.docCount === 0 && data[i].ackStatus != key.isChecked) {
        status = {
          pfId: key.pfId,
          subscribed: key.isChecked
        }
        ackStatus.push(status);
      }
    });
    finalAckStatus = ackStatus;
    this.setState({ ackStatus: ackStatus });
  }

  renderListItems = () => {
    const assets = this.state.selectedStates;
    const { i18n: { messages } } = this.props;

    return assets.map((item, index) => {
      let branchCodeUpdated;
      switch (item.branchCode) {
        case 1:
          branchCodeUpdated = "SG";
          break;
        case 2:
          branchCodeUpdated = "HK";
          break;
        case 3:
          branchCodeUpdated = "US";
          break;
        case 4:
          branchCodeUpdated = "CH";
          break;
        default:
          branchCodeUpdated = "SG";
          break;
      }

      return (
        <ListItem onClick={() => this.handleChange(item)} className={item.docCount === 0 ? "docsignsubscription__list-item" : "docsignsubscription__list-item-disabled"}>

          <span className="docsignsubscription__list-item-value">{item.pfId}  {branchCodeUpdated}  {item.pfType}</span>
          <span className="docsignsubscription__list-item-value">
            {item.docCount === 0 &&
              <Checkbox
                onChange={() => this.handleChange(item)}
                checked={item.isChecked}
                name='docsign_subscription'
              />
            }
          </span>
        </ListItem>
      );
    });
  }

  renderTabletBlock = () => {
    return (
      <div>
        <List className="docsignsubscription__list" fullWidth>
          {
            this.renderListItems()
          }
        </List>
      </div>
    );
  }

  handleOnSelectAll = () => {
    const { checkeCount } = this.state;
    this.selectAll();
    return true;
  }

  renderDocsignSelectAll = () => {
    const { i18n: { messages } } = this.props;
    const { checkeCount, count } = this.state;
    const checked = checkeCount === count;

    return (
      <div className="docsignsubscription__selected-number">
        <span className="docsignsubscription__current-selected">
          {checkeCount} {messages['app.profile.consolidated.of']} {count} {messages['app.profile.consolidated.selected']}
        </span>
        <div>
          <span onClick={this.handleOnSelectAll} className="docsignsubscription__select-all">
            {
              messages['app.profile.consolidatesetup.selectAll']
            }
          </span>
          <Checkbox
            checked={checked}
            onChange={this.handleOnSelectAll}
          />
        </div>
      </div>
    );
  }

  modalContent = () => {
    const {
      susbscriptionConfirmed,
      termsConditionsClicked,
      accountDeSelectConfirmationPopUp,
      deactivatedAllPortfoliosPopup
    } = this.state;

    const { i18n: { messages }, screen } = this.props;

    if (termsConditionsClicked === true) {
      return (
        <Modal
          isActive={termsConditionsClicked}
          onClose={this.termsConditionsButtonClicked}
          header={messages['app.profile.terms.headLine']}
          content={
            <TermsConditions {...this.props} />
          }
        />
      );
    }
    if (accountDeSelectConfirmationPopUp) {
      return (
        <Modal
          isActive={accountDeSelectConfirmationPopUp}
          hideCloseButton
          header={messages['app.docsign.pageTitle.subscriptionConfirmation']}
          content={
            <div className="docsignsubscription-modal">
              {messages['app.docsign.susbscription.deselected.all']}
              <div>
                {messages['app.docsign.susbscription.are.you.sure']}
              </div>
              <div className="docsignsubscription-modal__action">
                <div className="row">
                  <div className="btn docsignsubscription-modal__button-width">
                    <Button fullWidth onPress={this.confirmDeselectAllClicked}>
                      {messages['app.common.alert.yes']}
                    </Button>
                  </div>
                  <div className="btn docsignsubscription-modal__button-width">
                    <Button fullWidth onPress={this.deselectConfirmNo}>
                      {messages['app.common.alert.no']}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          }
        />
      );
    }
    if(deactivatedAllPortfoliosPopup){
      return (
        <Modal
          isActive={deactivatedAllPortfoliosPopup}
          hideCloseButton
          header={messages['app.docsign.pageTitle.subscriptionConfirmation']}
          content={
            <div className="docsignsubscription-modal">
              {messages['app.docsign.susbscription.accounts.deactivated']}
              <div>
              {messages['app.docsign.susbscription.service.deactivated']}
              </div>
              <div className="docsignsubscription-modal__action">
                <div className="docsignsubscription-modal__button-width">
                  <Button fullWidth onPress={this.goToPortfolio}>
                    {messages['app.calendar.doneBtn']}
                  </Button>
                </div>
              </div>
            </div>
          }
        />
      );
    }
    if (susbscriptionConfirmed === true) {
      return (
        <Modal
          isActive={susbscriptionConfirmed}
          hideCloseButton
          header={messages['app.docsign.pageTitle.subscriptionConfirmation']}
          content={
            <div className="docsignsubscription-modal">
              {messages['app.docsign.susbscription.confirmation']}
              <div className="docsignsubscription-modal__action">
                <div className="docsignsubscription-modal__button-width">
                  <Button fullWidth onPress={this.goToPortfolio}>
                    {messages['app.calendar.doneBtn']}
                  </Button>
                </div>
              </div>
            </div>
          }
        />
      );
    }
  }

  deselectConfirmNo = () => {
    this.setState({ accountDeSelectConfirmationPopUp: false });
  }

  confirmDeselectAllClicked = () => {
    this.setState({
      saveDocSignSubscriptionButtonClicked: true,
      accountDeSelectConfirmationPopUp: false,
      deactivatedAllPortfolios: true
    });
    this.props.saveDocSignSubscription(this.state.ackStatus);
  };

  render() {
    const { i18n: { messages }, docsign, accountDeSelectConfirmationPopUp } = this.props;
    const {
      warningMsg, saveDocSignSubscriptionButtonClicked, ackStatus
    } = this.state;

    if (warningMsg || ((docsign.subscriptionData == null) && (docsign.subscriptionData != undefined))) {
      return (
        <div className="scene">
          <div className="docsignsubscription__warningMsg">
            <Large secondary>{messages['app.profile.consolidatesetup.dataRes']}</Large>
          </div>
        </div>
      );
    }
    return (
      <div>
        <ScrollableLayout
          testID="Docsign-Subscription"
          body={
            <div className="row docsignsubscription">
              <div className="columns small-12 large-12  docsignsubscription-container">
                <div className="docsignsubscription__title">
                  <h2>{messages['app.common.pageTitle.esignature']}</h2>
                </div>
                <div className="docsignsubscription__subtitle">
                  <h4>{messages['app.profile.docsign.subTitle']}</h4>
                </div>
                <div className="docsignsubscription__subtitle">
                  <h4>{messages['app.docsign.susbscription.account.pending']}</h4>
                </div>
                <div className="docsignsubscription__content">
                  {
                    this.renderDocsignSelectAll()
                  }
                  {
                    this.renderTabletBlock()
                  }
                  <div className="docsignsubscription__tnc-message margin-left-20 margin-top-10" >
                    <span>{messages['app.docsign.susbscription.tnc']}</span>
                    <a onClick={this.termsConditionsButtonClicked}>
                      {messages['app.login.terms&condtn']}&nbsp;
                    </a>
                    <span>{messages['app.common.condition.text']}</span>
                  </div>
                  <div className="docsignsubscription__action-container">
                    <div className="docsignsubscription__button-width">
                      <Button
                        className="docsignsubscription__button"
                        fullWidth
                        disabled={ackStatus.length === 0 && !this.props.docsign.showDocsignBanner}
                        loading={saveDocSignSubscriptionButtonClicked}
                        onPress={this.saveDocSignSubscriptionClicked}>
                        {messages['app.profile.notification.saveButton']}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        />
        {this.modalContent()}
      </div>
    );
  }
}

export default createContainer({
  $renderError: () => <Error />,
  $renderLoading: () => <LoadingCircle isPage={true} />,
  $queries: {
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        }
      }
    },
    getDocSignSubscriptionData: {
      $call: 'docsign.getClientSub',
    },
    saveDocSignSubscription: {
      $call: 'docsign.saveClientSub',
    },
    docsign: {
      subscriptionData: true,
      saveClientSubscriptionResponse: true,
      showDocsignBanner: true,
      firstTimeSubscription: true

    },
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    setFirstTimeSubscription: { $set: 'docsign.firstTimeSubscription' },
    screen: {
      width: true,
      height: true,
      isSmall: true
    },
  },
}, ({ app, ...queries }) => ({
  ...queries,
}))(DocSignSubscription);






